import {IFlash} from "~/interfaces/flashInterfaces";
import {FlashMode} from "~/helpers/flashHelper";

export default function (filters) {
  return {
    namespaced: true,
    state: {
      dashboardDrilldownFilters: filters,
    },
    mutations: {
      setDashboardDrilldownFilters(state, newState) {
        state.dashboardDrilldownFilters = newState
      },
      removeDashboardDrilldownFilter(state, filterId) {
        state.dashboardDrilldownFilters = state.dashboardDrilldownFilters.filter(x => x.id !== filterId);
      },
    },
  };
}